export const leadZero = (value: number | undefined | null) =>
    String(value ?? 0).padStart(2, "0");

export const dateToApi = (date: Date | string | number | undefined | null) => {
    if (!date) {
        return 0;
    }

    const d = new Date(date);

    const year = d.getFullYear();
    const month = d.getMonth() + 1;
    const day = d.getDate();

    return day + month * 100 + year * 10000;
};

export function dateFromApi(date: number): Date;
export function dateFromApi(date: null | undefined): null;
export function dateFromApi(date: number | null | undefined): Date | null;

export function dateFromApi(date: number | undefined | null) {
    if (!date) {
        return null;
    }

    const day = date % 100;
    const month = Math.floor(date / 100) % 100;
    const year = Math.floor(date / 10000);

    return new Date(year, month - 1, day);
}

export const stringDateFromApi = (date: number | undefined | null) => {
    const d = dateFromApi(date);

    if (!d) {
        return "";
    }

    const year = d.getFullYear();
    const month = d.getMonth() + 1;
    const day = d.getDate();
    const hour = d.getHours();
    const minute = d.getMinutes();
    const second = d.getSeconds();

    return `${year}-${leadZero(month)}-${leadZero(day)}T${leadZero(
        hour,
    )}:${leadZero(minute)}:${leadZero(second)}`;
};

export const equalsApiDate = (dateApi: number, date: Date) => {
    const ad = dateApi % 100;
    const am = Math.floor(dateApi / 100) % 100;
    const ay = Math.floor(dateApi / 10000);

    return (
        ay === date.getFullYear() &&
        am === date.getMonth() + 1 &&
        ad === date.getDate()
    );
};

export const getTimezoneOffset = (timeZone: string) => {
    const d = new Date();

    d.setMilliseconds(0);

    return Date.parse(d.toLocaleString("en-US", { timeZone })) - d.getTime();
};

export const dateFromTimezone = (dateTime: string, timeZone: string) => {
    const date = new Date(dateTime);

    return new Date(date.getTime() - getTimezoneOffset(timeZone));
};
